import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AuthenticatedDocumentImage = ({ src, alt = '' }) => {
    const [objectUrl, setObjectUrl] = useState(null);

    useEffect(() => {
        let currentObjectUrl = null;
        const requestSource = axios.CancelToken.source();

        axios.get(src, {
            responseType: 'blob',
            cancelToken: requestSource.token
        }).then(response => {
            currentObjectUrl = URL.createObjectURL(response.data);
            setObjectUrl(currentObjectUrl);
        }).catch(error => {
            if (!axios.isCancel(error)) {
                console.error('GET_DOCUMENT_THUMBNAIL', error); // eslint-disable-line
            }
        });

        return () => {
            requestSource.cancel();
            if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        };
    }, [src]);

    return objectUrl ? <img src={objectUrl} alt={alt} /> : null;
};

export default AuthenticatedDocumentImage;
